  /* PERF (3 sep 2026) — second ("hover") photo on demand.
     Every product card used to download its hover image up front (19 files,
     311 KB on a collection page; the first card's copy even at High priority
     next to the LCP image) although it only shows on desktop hover or the
     mobile long-press below. product-card-*.liquid now renders that <img>
     with data-src / data-srcset and a blank placeholder; the block below
     copies them to the real attributes on the first interaction with a card:
     mouse/pen hover (pointerenter, capture — the event does not bubble),
     keyboard focus (focusin) and the touch hold (activate() further down).
     Runs on every device; the touch section keeps its own matchMedia exit.
     Cards whose hover image is already live (no data-src) are untouched. */
  (function () {
    function promoteHoverImage(card) {
      if (!card) return;
      var imgs = card.querySelectorAll('.m-product-card__hover-image img[data-src]');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        var srcset = img.getAttribute('data-srcset');
        if (srcset) {
          img.setAttribute('srcset', srcset);
          img.removeAttribute('data-srcset');
        }
        img.setAttribute('src', img.getAttribute('data-src'));
        img.removeAttribute('data-src');
      }
    }
    function onEnter(e) {
      if (e.pointerType === 'touch') return; // touch is handled by the hold below
      var t = e.target;
      if (!t || !t.closest) return;
      var card = t.closest('.m-product-card');
      if (card) promoteHoverImage(card);
    }
    document.addEventListener('pointerenter', onEnter, true);
    document.addEventListener('focusin', onEnter);
    window.hdPromoteHoverImage = promoteHoverImage;
  })();

  (function () {
    var mq = window.matchMedia('(hover: none) and (pointer: coarse)');
    if (!mq.matches) return;

    var HOLD_MS = 300; // below this a touch stays an ordinary tap
    var MOVE_TOL = 12; // px of drift that turns the gesture into a scroll
    var CLICK_GUARD_MS = 800;

    var pending = null; // gesture in progress: {card, x, y, timer}
    var activeCard = null; // card currently showing photo 2
    var armed = false; // this gesture must not navigate
    var suppressCard = null; // card whose link may not fire a click yet
    var suppressUntil = 0;

    function cancelPending() {
      if (pending && pending.timer) clearTimeout(pending.timer);
      pending = null;
    }

    function clearPreview() {
      if (!activeCard) return;
      activeCard.classList.remove('hd-touch-preview');
      activeCard = null;
    }

    function activate(card) {
      if (pending) pending.timer = null;
      armed = true; // the release of this hold must not open the PDP
      suppressCard = card;
      if (card === activeCard) {
        clearPreview(); // holding a previewed card flips it back
        return;
      }
      clearPreview();
      card.classList.add('hd-touch-preview');
      activeCard = card;
    }

    document.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length > 1) {
          cancelPending();
          return;
        }
        var target = e.target;
        if (!target || !target.closest) return;

        var media = target.closest('.m-product-card__media');
        var card = media && media.closest('.m-product-card');

        // Touching anything but the previewed card is this platform's
        // equivalent of moving the mouse away.
        if (activeCard && card !== activeCard) clearPreview();

        if (!media || !card) return;
        // Quick add, wishlist, quickview and compare live inside __media.
        if (target.closest('button, product-form, .m-product-card__action, .m-tooltip, input, select, label')) {
          return;
        }
        if (!card.querySelector('.m-product-card__hover-image')) return;

        var t = e.touches[0];
        pending = { card: card, x: t.clientX, y: t.clientY, timer: null };
        pending.timer = setTimeout(function () {
          // PERF (3 sep 2026): start the hover-image download the moment the
          // hold is recognised (300 ms in), inside the 0.8 s crossfade.
          if (window.hdPromoteHoverImage) window.hdPromoteHoverImage(card);
          activate(card);
        }, HOLD_MS);
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (e) {
        if (!pending || !e.touches.length) return;
        var t = e.touches[0];
        if (Math.abs(t.clientX - pending.x) > MOVE_TOL || Math.abs(t.clientY - pending.y) > MOVE_TOL) {
          cancelPending(); // scrolling or swiping a carousel, not a hold
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function (e) {
        cancelPending();
        if (!armed) return;
        armed = false;
        // Kills the synthetic click on every engine that emits one; the
        // capture listener below covers the ones that fire it anyway.
        if (e.cancelable) e.preventDefault();
        suppressUntil = Date.now() + CLICK_GUARD_MS;
      },
      { passive: false }
    );

    document.addEventListener(
      'touchcancel',
      function () {
        cancelPending();
        armed = false;
      },
      { passive: true }
    );

    // Only the card link is cancelled — never a button. Add to cart, quick
    // add and wishlist sit outside `a.m-product-card__link`, so a visitor who
    // previews an image and then hits Add to cart is not swallowed by this.
    document.addEventListener(
      'click',
      function (e) {
        if (!suppressUntil || Date.now() > suppressUntil) return;
        var link = e.target && e.target.closest && e.target.closest('a.m-product-card__link');
        if (!link || !suppressCard || !suppressCard.contains(link)) return;
        suppressUntil = 0;
        suppressCard = null;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    // Android raises the context menu on its own long-press timer, which
    // would land on top of the preview.
    document.addEventListener(
      'contextmenu',
      function (e) {
        if (!armed && !suppressUntil) return;
        if (e.target && e.target.closest && e.target.closest('.m-product-card__media')) {
          e.preventDefault();
        }
      },
      true
    );

    // Coming back from a PDP through the bfcache restores the DOM as it was
    // left, preview class included.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) clearPreview();
    });
  })();